import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ActivatedRoute, Params, Router } from '@angular/router';
@Injectable({
    providedIn: 'root'
  })

  export class RegistrationRoutingService{

    constructor(private readonly activatedRoute: ActivatedRoute, public readonly router: Router, private readonly http: HttpClient){}

    routeTo(webSource?: string | null): void {
      if (webSource != null && webSource !== '') {
        if (webSource.toLowerCase() === 'branches') {
          this.router.navigateByUrl(`/page-not-found${this.queryStringParams()}`);
        } else {
          this.router.navigateByUrl(`/register${this.queryStringParams()}`);
        }
      } else {
        this.router.navigateByUrl(`/register${this.queryStringParams()}`);
      }
    }

    queryStringParams() { //check there if query strings are there then one by one take in loop and append in one url
        let queryString = '';
        this.activatedRoute.queryParamMap.subscribe((params) => {

          let num = 0;
          while (num < params.keys.length) {
            let splitChar = '&';
            if (num == 0) {
              splitChar = '?';
            }
            queryString += splitChar + params.keys[num] + '=' + params["params"][params.keys[num]];
            num++;
          }

        });
        return queryString;
      }

  }
